import { addMonths, format, startOfYear } from "date-fns";
import { dateFnsLocale, fiLocale, svLocale } from "./language.helpers";
import { t } from "i18next";

export const BEGINNING_STATISTICS_DATE = "2020-05-02";

/**
 * Host that OAuth providers redirect back to during local development. Set
 * VITE_OAUTH_REDIRECT_HOST in .env when running the dev server behind a tunnel
 * (e.g. ngrok) so the provider can reach it; defaults to the plain dev server.
 * Never hardcode a personal tunnel URL here — .env is gitignored, this file is not.
 */
export const LOCAL_OAUTH_REDIRECT_HOST =
  import.meta.env.VITE_OAUTH_REDIRECT_HOST || "http://localhost:5173";

const MONTHS = (short?: boolean) => {
  const locale = dateFnsLocale();
  const first = startOfYear(new Date());
  return Array.from(Array(12)).map((_, i) =>
    format(addMonths(first, i), short ? "LLL" : "LLLL", { locale })
  );
};

export const MONTHS_SHORT = () => MONTHS(true);

export const SKILLSTER_ORGANIZATION_ID = 1;
export const SKILLSTER_SCHOOL_ID = 25;

export const SKILLSTER_DEMO_ORGANIZATION_ID = 62;
export const SKILLSTER_DEMO_ORGANIZATION_ID_FINLAND = 193;
export const SKILLSTER_ORGANIZATION_IDS = [
  SKILLSTER_ORGANIZATION_ID,
  SKILLSTER_DEMO_ORGANIZATION_ID,
  SKILLSTER_DEMO_ORGANIZATION_ID_FINLAND,
];

export const ADMIN_ROLE = { label: "Admin", value: "1" };

export const getStandardRoles = (language?: string) => [
  {
    label: t("common.roles.student", { lng: language || undefined }),
    value: "3",
  },
  {
    label: t("common.roles.teacher", { lng: language || undefined }),
    value: "2",
  },
];

export const createRoles = ({
  includeAdmin,
  languageOverride,
}: {
  includeAdmin?: boolean;
  languageOverride?: string;
}) =>
  includeAdmin
    ? [ADMIN_ROLE, ...getStandardRoles(languageOverride)]
    : getStandardRoles(languageOverride);

export const getRolesMap = (languageOverride?: string): Map<number, string> => {
  const roles = createRoles({ includeAdmin: true, languageOverride });
  const map = new Map<number, string>();
  roles.forEach((role) => {
    map.set(Number(role.value), role.label);
  });
  return map;
};

export const generateManualUrl = () =>
  svLocale()
    ? "https://res.cloudinary.com/dy7i8hekz/image/upload/v1683057604/L%C3%A4rarverktyget/Manualer/skillster-manual-sv_zczljx.pdf"
    : fiLocale()
      ? "https://res.cloudinary.com/dy7i8hekz/image/upload/v1683057605/L%C3%A4rarverktyget/Manualer/skillster-manual-fi_lgwv81.pdf"
      : "https://res.cloudinary.com/dy7i8hekz/image/upload/v1683057597/L%C3%A4rarverktyget/Manualer/skillster-manual-en_l9crgp.pdf";

export const COURSE_CARD_GRID_BREAKPOINTS = {
  base: 1,
  xs: 2,
  sm: 4,
  md: 6,
  lg: 7,
};
